import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {VehicleStatus} from '../../../shared/constants/vehicle-status'

@Component({
    selector   : 'nw-countdown-timer-v1',
    templateUrl: './countdown-timer-v1.component.html',
    styleUrls: ['./countdown-timer-v1.component.scss']
})
export class CountdownTimerV1Component implements OnInit, OnDestroy {
    @Input() timerLeft: number;
    @Input() offset: number = 1;
    @Input() timerLabel: string;
    @Input() timerEndLabel: string;
    @Input() vehicleStatus: string;
    @Input() auctionStartTimeLeft: number;
    @Input() isPreviewPeriod: boolean;
    @Input() timerImage: string;
    @Input() auctionRemainingEndTime: number;
    @Input() actualStartTime: number;

    days; hours; minutes; seconds;
    showTimerLeftSection: boolean;
    showTimerEndLabelSection: boolean;
    private timerInterval: any;
    constructor() {
    }

    ngOnInit() {
        this.showTimerLeftSection = false;
        this.showTimerEndLabelSection = false;
        this.timerInterval = setInterval(() => {
            this.getCountdown();
        }, 1000);
    }

    getCountdown() {
        if (!!this.vehicleStatus && this.vehicleStatus.toUpperCase() === VehicleStatus.IN_TRANSIT && this.auctionStartTimeLeft >=  this.offset * 1000) {
            this.showTimerLeftSection = false;
            this.showTimerEndLabelSection = false;
            this.auctionStartTimeLeft = this.auctionStartTimeLeft - 1000;
            if (this.timerLeft >= this.offset * 1000) {
                this.timerLeft = this.timerLeft - 1000;
            }
        } else if (this.timerLeft >= this.offset * 1000) {
            this.showTimerLeftSection = true;
            this.showTimerEndLabelSection = false;
            let seconds_left = this.timerLeft / 1000;
            this.days = parseInt((seconds_left / 86400).toString(), 10);
            seconds_left = seconds_left % 86400;

            this.hours = parseInt((seconds_left / 3600).toString(), 10);
            seconds_left = seconds_left % 3600;

            this.minutes = parseInt((seconds_left / 60).toString(), 10);
            this.seconds = parseInt((seconds_left % 60).toString(), 10);
            this.timerLeft = this.timerLeft - 1000;
        } else {
            // hide 'Sale Begins soon' if actualStartTime exist
            this.showTimerEndLabelSection = !this.actualStartTime;
            this.showTimerLeftSection = false;
            this.timerLeft = 0;
        }
    }

    ngOnDestroy() {
        clearInterval(this.timerInterval);
    }

}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/countdown-timer-v1/countdown-timer-v1.component.ts